import React from "react";

const NotificationCards = ({ notification }) => {
  const notificationText = {
    TableReject: "Table Rejected",
    TableApproved: "Table Approved",
    EventAutoCancel: "Table Cancelled",
    bookingConfirm: "Congratulations!",
    Refund: "Refund",
    eventCompleteStatus: "Table Completed",
    reminder: "Reminder",
  };

  return (
    <div className="w-full navbar_dropdown-link2 w-inline-block pointernone notifdisp">
      <div className="notification-image w-16">
        <img
          loading="lazy"
          src="	https://s3.ap-south-1.amazonaws.com/high-table-2024/public/photo/members/members-photo-1401.png"
          alt="Hightable-user-icon"
          className="rounded-full h-6 w-6 objcvr"
        />
      </div>
      <div className="v3-uui-navbar08_item-right">
        <div className="notification-title">
          {notificationText[notification?.type] || "Unknown Notification"}
        </div>
        <div className="notification-description">{notification?.message}</div>
      </div>
    </div>
  );
};

export default NotificationCards;
